import React from 'react';
import ReactDOM from 'react-dom';

const el = document.querySelector('.hpi-test-element');
const spanElement = React.createElement('span', {}, 'SPAN!');

if (el) {
    ReactDOM.render(spanElement,el)
}